// React library
import React from 'react';
import '../../Assets/Components/MessageBox.css';
// Kendo controls
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { Button } from '@progress/kendo-react-buttons';

export const Pattern = {
    Ok: 1,
    OkCancel: 2,
    YesNo: 3,
    YesNoCancel: 4
}

export const ConfirmMessageResult = {
    Blank: 1,
    Yes: 2,
    No: 3,
    Cancel: 4,
}

export const Title = {
    DefaultTitle: "PRONEXUS WORKS",
    Alert: "情報",
    Warning: "警告",
    Error: "エラー発生",
    Confirm: "確認"
};

const Caption = {
    Ok: "OK",
    Cancel: "キャンセル",
    Yes: "はい",
    No: "いいえ"
}

const icon = '/' + process.env.REACT_APP_SUB_FOLDER + '/PronexusWorksLogo.ico';

export default function MessageBox(props) {
    // Mapping state from store
    const sid = props.sid;
    const title = props.title;
    const pattern = props.pattern;
    const message = props.message;
    const caption = Caption;

    const onSubmit = (result) => {
        // Call parent event
        props.submit(sid, result);
    }

    const renderPattern = () => {
        switch (pattern) {
            case Pattern.Ok:
                return <Button className="dialogButton"
                    onClick={() => onSubmit(ConfirmMessageResult.Yes)}>
                    {caption.Ok}
                </Button>

            case Pattern.OkCancel:
                return <React.Fragment>
                    <Button className="dialogButton"
                        onClick={() => onSubmit(ConfirmMessageResult.Yes)}>
                        {caption.Ok}
                    </Button>
                    <Button className="dialogButton"
                        onClick={() => onSubmit(ConfirmMessageResult.Cancel)}>
                        {caption.Cancel}
                    </Button>
                </React.Fragment>

            case Pattern.YesNo:
                return <React.Fragment>
                    <Button className="dialogButton"
                        onClick={() => onSubmit(ConfirmMessageResult.Yes)}>
                        {caption.Yes}
                    </Button>
                    <Button className="dialogButton"
                        onClick={() => onSubmit(ConfirmMessageResult.No)}>
                        {caption.No}
                    </Button>
                </React.Fragment>

            case Pattern.YesNoCancel:
                return <React.Fragment>
                    <Button className="dialogButton"
                        onClick={() => onSubmit(ConfirmMessageResult.Yes)}>
                        {caption.Yes}
                    </Button>
                    <Button className="dialogButton"
                        onClick={() => onSubmit(ConfirmMessageResult.No)}>
                        {caption.No}
                    </Button>
                    <Button className="dialogButton"
                        onClick={() => onSubmit(ConfirmMessageResult.Cancel)}>
                        {caption.Cancel}
                    </Button>
                </React.Fragment>

            default:
                return null;
        }
    }

    return (
        <Dialog title={
            <div className="txtTitle">
                <img className="pnxImg" src={icon} alt={title} />
                {title}
            </div>}
            caption={caption}
            onClose={() => onSubmit(ConfirmMessageResult.Blank)}>
            <div className="dialogContent content-size">
                <div className={message && message.length > 30 ? "mbContent" : ""}>
                    {message}
                </div>
            </div>
            <DialogActionsBar >
                {renderPattern()}
            </DialogActionsBar>
        </Dialog>
    );
}
